import segment from 'src/js/modules/analytics/segment';

const trackUpgradeRedirect = (trackingData) =>
  segment.trackAsync(segment.constants.events.UPGRADE_INITIATED, {
    ...trackingData,
    productCategory: segment.constants.common.EDITOR_PRODUCT_CATEGORY,
    trial: false,
  });

export default trackUpgradeRedirect;
